import React from 'react';

import { FileUploadIcon } from './FileUploadIcon';

export const FileUploadOnlyPDFIcon = () => {
  return <FileUploadIcon onlyPdf />;
};
